// Layout
import { TranslationService } from '@/utils/services/TranslationService';

import { INTEGRATIONS } from '@/lib/routes/privateRoutes';

import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
// Components
import PageContent from '@/components/pages/settings/integrations/PageContent';
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';

const Page = () => {
    return (
        <SettingsWrapper>
            <SettingsWrapper.MainContent>
                <PageContent />
            </SettingsWrapper.MainContent>
        </SettingsWrapper>
    );
};

const Integrations = () => {
    return (
        <WrapperSwitchLayout noPadding={true} disableMainScroll={true}>
            <Page />
        </WrapperSwitchLayout>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(INTEGRATIONS);

export default Integrations;
